import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import SiteLayout from "@/site/SiteLayout";
import SiteHome from "@/site/pages/SiteHome";
import SiteAbout from "@/site/pages/SiteAbout";
import SiteServices from "@/site/pages/SiteServices";
import SiteDoctors from "@/site/pages/SiteDoctors";
import SiteRdv from "@/site/pages/SiteRdv";
import SiteTele from "@/site/pages/SiteTele";
import SiteContact from "@/site/pages/SiteContact";
import SiteJournal from "@/site/pages/SiteJournal";
import SiteArticle from "@/site/pages/SiteArticle";
import SiteReview from "@/site/pages/SiteReview";
import SitePartners from "@/site/pages/SitePartners";
import SiteLegal from "@/site/pages/SiteLegal";
import SiteGallery from "@/site/pages/SiteGallery";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<SiteHome />} />
            <Route path="/a-propos" element={<SiteAbout />} />
            <Route path="/services" element={<SiteServices />} />
            <Route path="/medecins" element={<SiteDoctors />} />
            <Route path="/rendez-vous" element={<SiteRdv />} />
            <Route path="/teleconsultation" element={<SiteTele />} />
            <Route path="/journal" element={<SiteJournal />} />
            <Route path="/journal/:slug" element={<SiteArticle />} />
            <Route path="/galerie" element={<SiteGallery />} />
            <Route path="/contact" element={<SiteContact />} />
            <Route path="/entreprises" element={<SitePartners />} />
            <Route path="/mentions-legales" element={<SiteLegal />} />
            <Route path="/confidentialite" element={<SiteLegal />} />
            <Route path="/avis/:token" element={<SiteReview />} />
          </Route>
          <Route path="/portail/*" element={<App />} />
          <Route path="*" element={<SiteLayout />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('New version available! Refresh to update.');
  },
  onSuccess: (registration) => {
    console.log('App is ready for offline use.');
  }
});
